export default __webpack_public_path__ + "static/media/dashboard.ce1495df.svg";